import { render, staticRenderFns } from "./user-edit-box2.vue?vue&type=template&id=18963e0d&scoped=true&"
import script from "./user-edit-box2.vue?vue&type=script&lang=js&"
export * from "./user-edit-box2.vue?vue&type=script&lang=js&"
import style0 from "./user-edit-box2.vue?vue&type=style&index=0&id=18963e0d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18963e0d",
  null
  
)

export default component.exports